import React from "react";
import ConnectStore from "../ConnectStore";
import { motion } from "framer-motion";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";

const ConnectStoreLayout = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.3 } }}
      className={`${globalStyles?.pagePaddings} ${globalStyles.pageColumnGaps}`}
    >
      <div>
        <h4 className="mb-2">Connect a Store & Manage Items</h4>
        <p>
          Connect a chowdeck store to a Lumi Business store and manage their
          items
        </p>
      </div>
      <div>
        <ConnectStore />
      </div>
    </motion.div>
  );
};

export default ConnectStoreLayout;
